import { CustomTextField } from './../../../../../components/CustomTextField';
import { CustomSelectAndChildren } from './../../../../../components/CustomSelectAndChildren';
import { MenuItem } from '@mui/material';
import { MATERIAL_TYPE } from '../Model/Model';
import { CleanIcon } from '../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const TechnicalDetails = ({ item, disabled, emptyFields, handleChange, t, handleClearFields }) => {

    return (
        <>
            {!item?.id && (
                <div className='row d-flex justify-content-end m-3'>
                    <ButtonIcon
                        id='btn_td_clean_fields'
                        Icon={CleanIcon}
                        onClick={handleClearFields}
                        title={'clear_instances'}
                        className={'btn-clean-secondary-600'}
                        tooltipPlacement={'right'}
                        iconProps='btn-icon-svg-12px icon-color-general-00'
                    />
                </div>
            )}
            <div className='row'>
                <div className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomTextField
                        id='txt_td_brand'
                        name='brand'
                        value={item?.brand}
                        trans='brand'
                        type={'text'}
                        disabled={disabled}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                        required={true}
                        length={128}
                        placeholder={t('enter_brand_name')}
                    />
                </div>
                <div className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomTextField
                        id='txt_td_model'
                        name='model'
                        value={item?.model}
                        trans='model'
                        type={'text'}
                        disabled={disabled}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                        required={true}
                        length={128}
                        placeholder={t('enter_the_model')}
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomTextField
                        id='txt_td_seria_number'
                        name='serialNumber'
                        value={item?.serialNumber}
                        trans='serial_number'
                        type={'text'}
                        disabled={disabled}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                        required={true}
                        length={128}
                        placeholder={t('enter_the_serial_number')}
                    />
                </div>
                <div className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomSelectAndChildren
                        id='slt_td_equipment_owner'
                        name='equipmentOwner'
                        trans='material_type'
                        disabled={disabled}
                        onChange={handleChange}
                        value={item?.equipmentOwner}
                        emptyFields={emptyFields}
                        required={true}
                        showNoSelectionOption={false}
                        placeholder={t('select_material_type')}
                    >
                        {Object.entries(MATERIAL_TYPE).map(([key, mat]) => (
                            <MenuItem key={key} value={key}>
                                {t(mat.trans)}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
                <div>
                    <CustomTextField
                        length={512}
                        id='txt_td_specification'
                        name='specification'
                        value={item?.specification}
                        trans='specification'
                        required={false}
                        onChange={handleChange}
                        multiline={true}
                        row={4}
                        placeholder={t('technical_especifications')}
                    />
                </div>
            </div>
        </>
    );
};

export default TechnicalDetails;
